"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatTimeRangeFromIsoStrings = exports.formatTimeRange = exports.formatDateTimeFromIsoString = exports.isHourMinuteFormat = exports.formatDateTime = void 0;
var locale_1 = require("../locale");
var getPolyfillDateRange_1 = __importDefault(require("./getPolyfillDateRange"));
var constants_1 = require("../constants");
var formatDateTime = function (_a) {
    var date = _a.date, locale = _a.locale, dateOptions = _a.dateOptions, timeZone = _a.timeZone;
    dateOptions.timeZone = timeZone || 'UTC';
    var formattedDateTime = Intl.DateTimeFormat(locale, dateOptions).format(date);
    // special case for germany - append Uhr to currently returned time
    if (locale === locale_1.Locale.DE_DE && (0, exports.isHourMinuteFormat)(formattedDateTime)) {
        formattedDateTime += ' Uhr'.replace(/ /g, constants_1.NON_BREAKING_SPACE);
    }
    return formattedDateTime;
};
exports.formatDateTime = formatDateTime;
var isHourMinuteFormat = function (formattedDateTime) {
    return Number(formattedDateTime.split(':')[0]) <= 24 && Number(formattedDateTime.split(':')[1]) < 60;
};
exports.isHourMinuteFormat = isHourMinuteFormat;
var formatDateTimeFromIsoString = function (_a) {
    var isoString = _a.isoString, locale = _a.locale, dateOptions = _a.dateOptions, timeZone = _a.timeZone;
    var date = new Date(isoString);
    return (0, exports.formatDateTime)({
        date: date,
        locale: locale,
        dateOptions: dateOptions,
        timeZone: timeZone,
    });
};
exports.formatDateTimeFromIsoString = formatDateTimeFromIsoString;
var formatTimeRange = function (_a) {
    var startTime = _a.startTime, endTime = _a.endTime, locale = _a.locale, dateOptions = _a.dateOptions, timeZone = _a.timeZone;
    var timeRangeString = '';
    dateOptions.timeZone = timeZone || 'UTC';
    var dateTimeFormatter = Intl.DateTimeFormat(locale, dateOptions);
    if (typeof dateTimeFormatter.formatRange !== 'function') {
        var formattedStart = dateTimeFormatter.format(startTime);
        var formattedEnd = dateTimeFormatter.format(endTime);
        timeRangeString = (0, getPolyfillDateRange_1.default)(locale, formattedStart, formattedEnd);
    }
    else {
        timeRangeString = dateTimeFormatter.formatRange(startTime, endTime);
    }
    // replacing spaces with non-breaking spaces
    return timeRangeString.replace(/ /g, constants_1.NON_BREAKING_SPACE);
};
exports.formatTimeRange = formatTimeRange;
var formatTimeRangeFromIsoStrings = function (_a) {
    var startTimeIsoString = _a.startTimeIsoString, endTimeIsoString = _a.endTimeIsoString, locale = _a.locale, dateOptions = _a.dateOptions, timeZone = _a.timeZone;
    var startTime = new Date(startTimeIsoString);
    var endTime = new Date(endTimeIsoString);
    return (0, exports.formatTimeRange)({
        startTime: startTime,
        endTime: endTime,
        locale: locale,
        dateOptions: dateOptions,
        timeZone: timeZone,
    });
};
exports.formatTimeRangeFromIsoStrings = formatTimeRangeFromIsoStrings;
